module.exports = __webpack_public_path__ + "img/п.8.b146323a.png";